import { captureException } from "@sentry/react";
import React, { useEffect } from "react";

import Error from "./Error";

export default function ErrorBoundary({ error }) {
  useEffect(() => {
    captureException(error);

    if (import.meta.env.DEV) {
      console.error("[ErrorBoundary]", {
        message: error?.message,
        stack: error?.stack,
        cause: error?.cause,
      });
    }
  }, [error]);

  return <Error code={500} />;
}
